import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Templates

// Componentss
import { Page404Component } from '@nivelics/lib';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../../../login/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('../../../admin/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'Home' }
  },
  {
    path: 'cotizaciones',
    loadChildren: () => import('../../../estimation/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'Cotizaciones' }
  },
  {
    path: 'certificados',
    loadChildren: () => import('../../../certificates/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'Certificados' }
  },
  {
    path: 'integracion-jira',
    loadChildren: () => import('../../../jira-integration/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'Integración Jira' }
  },
  {
    path: 'gestion-proyectos',
    loadChildren: () => import('../../../project-management/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'Home' }
  },
  {
    path: 'gestion-equipos',
    loadChildren: () => import('../../../team-management/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'Home' }
  },
  {
    path: 'calidad',
    loadChildren: () => import('../../../quality-assurance/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'qa' }
  },
  {
    path: 'eventos',
    loadChildren: () => import('../../../events/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'Eventos' }
  },
  {
    path: 'ps',
    loadChildren: () => import('../../../ps/src/app/local-entry/local-entry.module').then(m => m.LocalEntryModule),
    data: { title: 'Peticiones y solicitudes' }
  },
  {
    path: '**',
    component: Page404Component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
